// Build and Price option sections in the desired order with section title and vehicleOptions API titles
export default {
    availableDriveTrainList: {
        title: 'Drive Type',
        optionsName: 'Drivetrain',
        mandatory: true,
    },
    availableEngineList: {
        title: 'Engine',
        optionsName: 'Engine',
        mandatory: true,
    },
    availableTransmissionList: {
        title: 'Transmission',
        optionsName: 'Transmission',
        mandatory: true,
    },
    exteriorColorList: {
        title: 'Exterior Color',
        optionsName: 'Exterior Colors',
        mandatory: true,
    },
    interiorColorList: {
        title: 'Interior Color',
        optionsName: 'Interior Colors',
        mandatory: true,
    },
    packageList: {
        title: 'Packages',
        optionsName: 'Packages',
        mandatory: false,
    },
};
